import { useRef, useEffect, useState } from 'react';
import classNames from 'classnames/bind';

import styles from './index.module.scss';

const cx = classNames.bind(styles);

const S06 = () => {
  const [isOverlap, setOverlap] = useState(false);
  const observeRef = useRef();

  useEffect(() => {
    if (observeRef.current) {
      const observer = new IntersectionObserver((entry) => {
        setOverlap(entry[0].isIntersecting);
      });
      observer.observe(observeRef.current);
    }
  }, []);

  return (
    <section className={cx('container')}>
      <div className={cx('wrapper')}>
        <h2 className={cx('title')}>
          Gentle Formulas,
          <br />
          Safe for All
        </h2>
        <p className={cx(['desc', isOverlap && 'enable'])}>
          Made with only safe and gentle ingredients
          <br />
          Trusted by families and tested for sensitive skin
          <br />
          Each formula is carefully managed from start to finish
          <br />
          Because your peace of mind matters most
        </p>
      </div>
      <div className={cx(['cover', isOverlap && 'enable'])} />
      <div ref={observeRef} className={cx('observe')} />
    </section>
  );
};

export default S06;
